export default "__VITE_PUBLIC_ASSET__1b13afea__"